var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBanner',{attrs:{"condition":_vm.isInvalidShipping}},[_c('p',[_vm._v("\n\t\tWe can only ship this product to the United States of America or\n\t\tCanada please update your shipping address to continue.\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }